import { render } from "./App.vue?vue&type=template&id=3b8decf0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3b8decf0&lang=scss"

import exportComponent from "C:\\Users\\wkphi\\Desktop\\Programming\\buthigame - Copy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__